import {
  showExportExtension,
  editExportExtension,
  createExportExtension,
  storeExportExtension,
  updateExportExtension,
  updateExtensionComment,
  storeExtensionComment,
  generateExtensionCertificate,
} from '@app/api/export-extention.api';
import { getCustomerImports } from '@app/api/import.api';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { notificationController } from '@app/controllers/notificationController';
import { ExportExtensionRequest } from '@app/models/export_extention/ExportExtentionRequest';
import { Form, notification, Tabs, Input, Select } from 'antd';
import { Tab } from 'rc-tabs/lib/interface';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ExportExtentionInfo from './ExportExtentionInfo';
import { DropdownOption } from '@app/models/DropdownOption';
import { authUserService } from '@app/services/authUser.service';
import { Customer } from '@app/models/customer/Customer';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { CustomerInfoForm } from '@app/components/forms/CustomerInfoForm/CustomerInfoForm';
import StatusBar from '@app/components/statusBar/statusBar';
import { CustomerDTO } from '@app/models/customer/CustomerDTO';
import { ImportDropdownItem } from '@app/models/import/ImportResponse';
import DocumentChecklist from './DocumentChecklist';
import ExportWorkflowButtons from './ExportWorkFlowButtons';
import CommentsSection from '../../common/Comment';
import { Comment as ExportComment } from '@app/models/export/ExportResponse';
import moment from 'moment';
import ExtensionCertificateTable from './ExtensionCertificate';
const { Search } = Input;

interface TypeOfForm {
  type: 'edit' | 'create' | 'view';
}

interface ExportExtentionProps extends TypeOfForm {
  editable: boolean;
  id?: string;
  export_id?: number | null;
  showEditIcon?: boolean;
  pageTitle: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setCurrentBreadcrumName: Function;
}

const ExportExtentionForm: React.FC<ExportExtentionProps> = ({
  editable = false,
  id,
  export_id,
  pageTitle,
  type,
  setCurrentBreadcrumName,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const navigate = useNavigate();
  const [referenceCode, setReferenceCode] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [comments, setComments] = useState([]);
  const [customerId, setCustomerId] = useState<number | null>(null);
  const [statusOptions, setStatusOptions] = useState<DropdownOption[]>([]);
  const [typeOptions, setTypeOptions] = useState<DropdownOption[]>([]);
  const [countries, setCountries] = useState<DropdownOption[]>([]);
  const [acceptedFields, setAcceptedFields] = useState([]);
  const user = authUserService.getUser();
  const { t } = useTranslation();
  const { addHeaderButton, removeHeaderButton } = useHeader();
  const [wfActions, setWfActions] = useState<string[]>([]);
  const [customerData, settCustomerData] = useState<CustomerDTO | null>(null);
  const [customerEmail, setCustomerEmail] = useState<string | null>(null);
  const [customerStatus, setCustomerStatus] = useState<string | null>(null);
  const [importOptions, setImportOptions] = useState<ImportDropdownItem[]>([]);
  const [selectedImport, setSelectedImport] = useState<any>(null);
  const [ExportExtentionData, setExportExtentionData] = useState<any>(null);
  const [product, setProduct] = useState<any>(null);
  const [lineData, setlineData] = useState<any>(null);
  const [additionalSubmittedDocs, setadditionalSubmittedDocs] = useState<any[]>([]);
  const exportExtentionId = id ? parseInt(id) : null;
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const [serviceCharges, setServiceCharges] = useState<any[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const [certificate, setCertificate] = useState<any | null>(null);
  const [canUpload, setCanUpload] = useState<any>(false);
  const [editableUser, setEditableUser] = useState<any>(false);
  const [canUpdateConfig, setCanUpdateConfig] = useState<any>(false);
  const usertype = JSON.parse(localStorage.getItem('user') || '{}')?.usertype || 'Unknown User';

  function setCustomerData(customer: Customer) {
    setCustomerId(customer?.id);
    form.setFieldsValue({
      uid: customer?.id,
      email: customer?.user?.email,
      name: customer?.name,
      customerStatus: customer?.user?.status,
      customerType: customer?.customer_type,
    });
  }
  // useEffect(() => {
  //   async function fetchExportExtensionData() {
  //     try {
  //       const ExportExtensionData = await editExportExtension(Number(id));
  //       console.log('Full editExportExtension data:', ExportExtensionData); // Debugging
  //       // Extract email & status from customer.user (if available)
  //       const customer = ExportExtensionData?.export_extension?.customer;
  //       if (customer) {
  //         settCustomerData(customer);
  //         setCustomerEmail(customer?.user?.email);
  //         setCustomerStatus(customer?.user?.status);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching follow-up data:', error);
  //     }
  //   }

  //   fetchExportExtensionData();
  // }, [editExportExtension, id]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const result = await editExportExtension(Number(id));
  //     } catch (error) {
  //       console.error('Error fetching export extension data:', error);
  //     }
  //   };

  //   if (id) {
  //     fetchData();
  //   }
  // }, [id]);

  const refreshCertificate = async () => {
    const res = await showExportExtension(Number(id));
    setApiData(res);
  };

  const setApiData = (res: any) => {
    const ext = res?.export_extension;

    setStatus(ext?.status ?? 'New');
    setStatusOptions(ext?.status ?? 'New');
    setCurrentBreadcrumName(ext?.code ?? 'New');
    setCode(ext?.code ?? 'N/A');
    setReferenceCode(ext?.reference_code ?? ext?.code ?? 'N/A');
    setAcceptedFields(ext?.accepted ?? []);
    setCountries(res?.countries ?? []);
    setCustomerId(ext?.customer_id ?? ext?.export?.customer_id ?? user?.customer?.id);
    setWfActions(res?.wf_actions ?? []);
    setExportExtentionData(ext ?? {});
    console.log('Export Extension Data:', ExportExtentionData);

    setServiceCharges(res?.service_charges ?? []);
    setadditionalSubmittedDocs(ext?.documents ?? []);
    setCertificate(
      ext?.certificate
        ? {
            ...ext.certificate,
          }
        : null,
    );
    setCanUpload(ext?.can_upload ?? false);
    setEditableUser(ext?.editable_for_usertype ?? false);
    setCanUpdateConfig(ext?.can_update_config ?? false);
    setComments(ext?.comments ?? []);

    const customer = res?.export_extension?.customer ?? {
      id: user?.id,
      name: user?.name,
      customer_type: 'CUSTOMER',
    };
    setCustomerData(customer);

    form.setFieldsValue({
      status: ext?.status,
      code: ext?.code || '',
      export_code: ext?.export?.code || '',
      expire_date: ext?.expire_date ? moment(ext.expire_date) : null,
      request_date: ext?.request_date ? moment(ext.request_date) : null,
      ext_no: ext?.ext_no || '',
      prv_ext_id: ext?.prv_ext_id || '',
    });
  };

  useEffect(() => {
    setIsFetching(true);
    // if (export_id && id) {
    if (type === 'view') {
      showExportExtension(Number(id))
        .then((res: any) => {
          setApiData(res);
          setIsFetching(false);
        })
        .catch((err: any) => {
          setLoading(false);
          notification.error({ message: 'Failed to fetch FollowUp', description: err.message });
          console.error(err);
        });
    } else if (type === 'edit') {
      editExportExtension(Number(id))
        .then((res: any) => {
          setApiData(res);
          setIsFetching(false);
        })
        .catch((err: any) => {
          setIsFetching(false);
          notification.error({ message: 'Failed to edit FollowUp', description: err.message });
          console.error(err);
        });
    }
    // } else
    if (type === 'create') {
      createExportExtension()
        .then((res: any) => {
          setApiData(res);
          setIsFetching(false);
        })
        .catch((err: any) => {
          setIsFetching(false);
          notification.error({ message: 'Failed to create FollowUp', description: err.message });
          console.error(err);
        });
    }
  }, [export_id, id, type, status]);

  const handleSubmit = (values: ExportExtensionRequest) => {
    const data = form.getFieldsValue();

    if (editable) {
      setLoading(true);

      const {
        product_id,
        service_id,
        line_type,
        qty,
        billing_qty,
        billing_days,
        start_date,
        end_date,
        expire_date,
        ...rest
      } = data;

      // let productLines: any[] = [];
      // let serviceLines: any[] = [];

      const submissionData = {
        ...rest,
        ...values,
        reference_code: String(referenceCode),
        customer_id: customerId,
        accepted: acceptedFields ?? [],
      };

      if (type === 'create') {
        storeExportExtension(submissionData)
          .then((res: any) => {
            setLoading(false);
            navigate(`/view-export-extension`, { state: { id: res?.data?.id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: err.message });
            setLoading(false);
          });
      } else if (type === 'edit' && export_id) {
        updateExportExtension(Number(id), submissionData)
          .then(() => {
            setLoading(false);
            navigate(`/view-export-extension`, { state: { id: exportExtentionId, export_id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: err.message });
            setLoading(false);
          });
      }
    }

    console.log('Form Submitted');
  };

  useEffect(() => {
    //console.log('Conditions for Edit btn: ', usertype, status, editableUser);
    const buttons = {
      'save-button': editable && (
        <BaseButton
          type="primary"
          loading={isLoading}
          size="small"
          onClick={() => {
            form
              .validateFields()
              .then((values) => {
                handleSubmit(values);
              })
              .catch((error) => {
                console.error('Validation failed:', error);
              });
          }}
        >
          {t('Save')}
        </BaseButton>
      ),
      'cancel-button': editable && (
        <BaseButton onClick={() => navigate('/export-extensions')} size="small" style={{ marginRight: '8px' }}>
          {t('Cancel')}
        </BaseButton>
      ),
      'edit-button': (type === 'view' ||
        (type !== 'edit' && exportExtentionId && editableUser) ||
        (usertype === 'ADMIN' && status === 'PENDING_APPROVAL' && type !== 'edit')) && (
        <BaseButton
          type="primary"
          onClick={() =>
            navigate('/edit-export-extension', {
              state: {
                id,
                export_id: ExportExtentionData?.export_id,
              },
            })
          }
          size="small"
          style={{ marginRight: '8px' }}
        >
          {t('Edit')}
        </BaseButton>
      ),
    };

    Object.entries(buttons).forEach(([key, button]) => {
      if (button) addHeaderButton(key, button);
    });

    return () => {
      Object.keys(buttons).forEach(removeHeaderButton);
    };
  }, [
    type,
    exportExtentionId,
    editable,
    addHeaderButton,
    removeHeaderButton,
    t,
    navigate,
    isLoading,
    form,
    handleSubmit,
    id,
    usertype,
    status,
    editableUser,
  ]);

  const items: Tab[] = [
    {
      key: '1',
      label: 'Customer Info',
      forceRender: true,
      children: (
        <CustomerInfoForm
          form={form}
          type="edit"
          customerInfo={customerData}
          // email={customerEmail}
          // status={customerStatus}
        />
      ),
    },
    {
      key: '2',
      label: 'Extension Info',
      forceRender: true,
      children: (
        <ExportExtentionInfo
          editable={editable}
          form={form}
          exportExtentionData={ExportExtentionData}
          status={null}
          editableUser={editableUser}
          updateConfig={canUpdateConfig}
        />
      ),
    },
    {
      key: '3',
      label: 'Documents',
      forceRender: true,
      children: (
        <DocumentChecklist
          exportExtensionId={id ?? ''}
          editable={editable}
          additionalSubmittedDocs={additionalSubmittedDocs}
          canUpload={canUpload}
        />
      ),
    },
    ...(status === 'PENDING_CERTIFICATE' || status === 'COMPLETED'
      ? [
          {
            key: '4',
            label: 'Extension Certificate',
            forceRender: true,
            children: (
              <ExtensionCertificateTable
                exportExtensionId={Number(id)}
                certificate={certificate || null}
                onGenerateCertificate={generateExtensionCertificate}
                onCertificateUpdate={(updated) => setCertificate(updated)}
                onRefresh={refreshCertificate}
              />
            ),
          },
        ]
      : []),
    {
      key: '5',
      label: 'Comments',
      forceRender: true,
      children: (
        <CommentsSection<ExportComment>
          commentData={comments}
          status={status}
          itemId={id?.toString() ?? ''}
          storeFn={storeExtensionComment}
          updateFn={updateExtensionComment}
        />
        // </div>
      ),
    },
  ];

  return (
    <>
      <BaseRow gutter={[16, 16]} style={{ width: '100%' }}>
        <BaseCol span={24}>
          <ExportWorkflowButtons
            id={id ?? null}
            export_id={export_id ?? null}
            status={status}
            setStatus={setStatus}
            wfActions={wfActions || []}
            currentType="NORMAL"
          />
        </BaseCol>

        <BaseCol span={24}>
          <BaseCard id="ExpExtension" title={pageTitle} padding="1.25rem">
            <BaseRow>
              <BaseCol span={24}>
                <Form
                  form={form}
                  name="ExpExtensionForm"
                  onFinish={handleSubmit}
                  labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
                  labelAlign="left"
                  labelWrap
                  wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
                  size="small"
                >
                  <Tabs items={type == 'create' ? items?.slice(0, 2) : items} />
                </Form>
              </BaseCol>
            </BaseRow>
          </BaseCard>
        </BaseCol>
      </BaseRow>
    </>
  );
};
export default ExportExtentionForm;
